import { render, staticRenderFns } from "./ParcelasTab.vue?vue&type=template&id=54286cdc"
import script from "./ParcelasTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelasTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports